export const config = {
  'development': {
    apiHost: "localhost",
    apiStorage: "https://t3-storage-stag.grupofacthum.com/api/v1",    
    
    // apiStorage: "http://192.168.0.166:3000/api/v1",    
    client: {
      url: 'http://localhost:3000/api'
    },
    originHost: 'http://localhost:3000',
  },
  'staging': {
    apiStorage: "https://t4-storage-stag.string-projects.com/api/v1",    
    apiHost: "staging.host",
    client: {
      url: 'https://metrics.selexi.it/api'
    },
    originHost: 'https://metrics.selexi.it',
  },
  'production': {
    apiHost: "production.host",
    apiStorage: "https://selexi-storage.string-projects.com/api/v1",
    client: {
      url: 'https://metrics.selexi.it/api'
    },
    originHost: 'https://selexi.string-projects',
  }
}

export default config;
